import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
appHeight();
addEvent();

import popupCalls from './script/popupCalls';
import mobMenu from './script/mobMenu';
import megamenu from './script/megamenu';
import stickyHeader from './script/stickyHeader';
import sliders from './script/slider';
import readMore from './script/readmore';
import tabs from './script/tabs';
import qtyCombo from './script/qtyCombo';
import accordian from './script/accordian';
import dropdown from './script/dropdowns';
import stickyFilters from './script/stickyFilters';
import numberInputs from './script/numberInputs';
import scrollCart from './script/cartLine';
import video from './script/video';
import variations from './script/variation';
import stickySidebar from './script/stickySidebar';
import subcat from './script/subcat';

popupCalls.init();
mobMenu.init();
megamenu.init();
stickyHeader.init();
sliders.init();
readMore.init();
tabs.init();
qtyCombo.init();
accordian.init();
dropdown.init();
stickyFilters.init();
numberInputs.init();
scrollCart.init();
video.init();
variations.init();
stickySidebar.init();
subcat.init();